import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import {
  useOnboardingPlannerViewSectionContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    padding: theme.spacing(0, 3),
  },
  header: {
  },
  content: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 2),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  question: {
    width: '100%',
  },
  moreOptionsIndicatorHidden: {
    opacity: 0,
  },
  text: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  totalLabel: {
    marginTop: theme.spacing(3),
  },
  totalText: {
    marginBottom: theme.spacing(4),
  },
  addButton: {
    width: 'fit-content',
    margin: 'auto',
  },
  footer: {},
  form: {
    padding: 0,
    position: 'relative',
  },
  forms: {
    marginTop: 0,
    marginBottom: -theme.spacing(1),
    padding: 0,
  },
});

function ViewSectionLayout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  const [expenseDetailResource] = resource.attr('sectionData');
  return (
    <div className={classes.root}>
      <OnboardingPlannerViewSectionHeader
        className={classes.header}
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <Box className={classes.content}>
        <MetaCollectionFormInline
          className={classes.form}
          collection={expenseDetailResource.attr('expenses')}
          metaOverrideConfig={{
          }}
          FormProps={{
            noIndividualSubmitButtons: true,
            LayoutProps: {
              hideErrorList: true,
            },
            FieldListProps: {
              hideErrorList: true,
            },
            className: classes.forms,
          }}
        />
      </Box>
    </div>
  );
}

ViewSectionLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

ViewSectionLayout.defaultProps = {
};

export default withStyles(styles)(ViewSectionLayout);
